export default "__VITE_ASSET__lEO20bvn__"